import { forwardRef, Provider, Type } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseComponent } from "ng/src/app/shared/base.component";

export class ControlValueAccessorComponent<T> extends BaseComponent implements ControlValueAccessor {
	
	protected onChange?: OnChangeFn<T>;
	protected onTouch?: OnTouchedFn;
	protected _disabled = false;
	protected _value: T | null = null;
	
	get value() {
		return this._value;
	}
	
	set value(val) {
		this.writeValue(val);
	}
	
	registerOnChange(fn: OnChangeFn<T>) {
		this.onChange = fn;
	}
	
	registerOnTouched(fn: OnTouchedFn) {
		this.onTouch = fn;
	}
	
	getDisabledState() {
		return this._disabled;
	}
	
	setDisabledState(isDisabled: boolean) {
		this._disabled = isDisabled;
	}
	
	writeValue(obj: T | null) {
		this._value = obj;
		this.onChange?.(obj);
	}
	
	static getValueAccessorProvider<T>(sourceComponent: Type<T>): Provider {
		return {
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => sourceComponent)
		}
	}
}

interface OnChangeFn<T> {
	(val: T | null): void
}

interface OnTouchedFn {
	(): void
}